import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CurrentDelayData } from "../models/CurrentDelayData";

export const getCurrentDelay = async (): Promise<CurrentDelayData | null> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		"[MILL].[GetCurrentDelayWeb]",
		parameters,
	);
	if (resp.ok) {
		const rows = get(resp, "data.tables[0].rows", []);
		if (rows.length === 0) {
			return null;
		}
		const row = rows[0];
		return {
			delayId: row.id ?? row.Id ?? null,
			delayActive: row.delayActive === 1 || row.delayActive === true,
			delayDeclared: row.delayDeclared === 1 || row.delayDeclared === true,
			currentDelaySeconds: row.currentDelaySeconds ?? 0,
			shiftDelaySeconds: row.shiftDelaySeconds ?? 0,
			currentDelayCode: row.currentDelayCodeString ?? null,
			delayStart: row.delayStart ?? null,
			delayEnd: row.delayEnd ?? null,
			delayCategoryId: row.DelayCategoryID ?? row.delayCategoryId ?? null,
			shiftGapTimeAvg: row.ShiftGapTimeAvg ?? 0,
			lastBilletGap: row.LastBilletGap ?? 0,
			finishLineSpeed: row.FinishLineSpeed ?? 0,
			barsInChains: row.BarsInChains ?? 0,
			barsInChainsSP: row.BarsInChainsSP ?? 0,
			lastDelayId: row.LastDelayId ?? null,
			lastDelayCodeId: row.LastDelayCodeId ?? null,
			lastDelayStart: row.LastDelayStartString ?? null,
			lastDelayEnd: row.LastDelayEndString ?? null,
			lastDelayComments: row.LastDelayComments ?? null,
			lastDelayCategoryId: row.LastDelayCategoryId ?? null,
			// Passing the Ball fields
			isBranchCode: row.isBranchCode === 1 || row.isBranchCode === true,
			branchPermissionAction: row.branchPermissionAction ?? null,
		};
	} else {
		throw new Error(resp.message || "Error fetching current delay data");
	}
};
